module.exports = __webpack_public_path__ + "split.29ee37b6.png";